import { Injectable, OnInit } from '@angular/core';
import { API, graphqlOperation } from 'aws-amplify';
import { GetStatisticsQuery } from 'src/app/API.service';
import { TimeSeriesData } from '../models/yearStatistics.model';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  constructor() {}

  getYearGraph(yearGraphStatistics: TimeSeriesData, selectedGraphName: string) {
    let converter: number = 1;
    if (selectedGraphName == 'Revenue') {
      converter = 0.33;
    }
    let series = Object.keys(yearGraphStatistics).map((key) => ({
      name: key,
      value: yearGraphStatistics[key] * converter,
      day: key,
    }));
    return [
      {
        name: 'Point',
        series: series,
      },
    ];
  }

  getWeekGraph(weekGraphStatistics: TimeSeriesData, selectedGraphName: string) {
    let converter: number = 1;
    if (selectedGraphName == 'Revenue') {
      converter = 0.33;
    }
    let series = Object.keys(weekGraphStatistics).map((key) => ({
      name: key,
      value: weekGraphStatistics[key] * converter,
      day: key,
    }));

    return [
      {
        name: 'Point',
        series: series,
      },
    ];
  }

  getMonthGraph(
    monthGraphStatistics: TimeSeriesData,
    selectedGraphName: string
  ) {
    let converter: number = 1;
    if (selectedGraphName == 'Revenue') {
      converter = 0.33;
    }
    let series = Object.keys(monthGraphStatistics).map((key, index) => ({
      name: (index + 1).toString(),
      value: monthGraphStatistics[key] * converter,
      day: (index + 1).toString(),
    }));
    return [
      {
        name: 'Point',
        series: series,
      },
    ];
  }

  getTotalGraph(
    totalGraphStatistics: TimeSeriesData,
    selectedGraphName: string
  ) {
    let converter: number = 1;
    if (selectedGraphName == 'Revenue') {
      converter = 0.33;
    }
    let series = Object.keys(totalGraphStatistics).map((key) => ({
      name: key,
      value: totalGraphStatistics[key] * converter,
      day: key,
    }));
    return [
      {
        name: 'Point' || '',
        series: series,
      },
    ];
  }

  async GetStatistics(timestamp?: string): Promise<GetStatisticsQuery> {
    const statement = `query GetStatistics($timestamp: String) {
        getStatistics(timestamp: $timestamp) {
          __typename
          scans
          clients
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (timestamp) {
      gqlAPIServiceArguments.timestamp = timestamp;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetStatisticsQuery>response.data.getStatistics;
  }
}
